import { COLORS } from '@mafc/common';
import { customStyled, Flex, Text } from '@mafc/trolly';

export const Delivery = customStyled(Flex)(props => {
  const conditionalStyle = props.isExpressUnavailable
    ? { background: props.theme.colors.error }
    : { paddingTop: 0 };
  return {
    padding: !props.isExpressUnavailable
      ? `${props.theme.space[3]}px 0`
      : `${props.theme.space[3]}px`,
    alignItems: 'center',
    justifyContent: 'space-between',
    borderTopLeftRadius: props.theme.space[2],
    borderTopRightRadius: props.theme.space[2],
    ...conditionalStyle,
  };
});

export const DeliveryInfo = customStyled(Flex)(() => ({
  alignItems: 'center',
}));

export const DeliveryTypeAndTime = customStyled(Text.Paragraph)(props => ({
  color: COLORS.BLACK,
  fontWeight: props.theme.fontWeights[6],
  fontSize: `${props.theme.fontSizes[1]}px`,
}));

export const DeliveryFee = customStyled(Text.Paragraph)(props => ({
  fontSize: `${props.theme.fontSizes[1]}px`,
}));

export const IconWrapper = customStyled(Flex)(props => ({
  alignItems: 'center',
  borderRadius: '50%',
  justifyContent: 'center',
  marginRight: `${props.theme.space[3]}px`,
}));
